import { FC, useContext, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AssociateSetupContext } from '@vs-online-only-app/state';
import { CenteredCardView } from '@vs-online-only-app/ui';
import IntroModulesLandingPage from './IntroModulesLandingPage';
import { IntroModulesProvider } from './IntroModulesContext';
import IntroModulesViewBody from './IntroModulesViewBody';
import IntroModulesFooter from './IntroModulesFooter';

const IntroModulesComponent: FC = () => (
  <IntroModulesProvider>
    <CenteredCardView
      body={<IntroModulesViewBody />}
      footer={<IntroModulesFooter />}
      noPadding
      size="large"
    />
  </IntroModulesProvider>
);

const IntroModulesView: FC = () => {
  const [showLandingPage, setShowLandingPage] = useState(true);
  const { hasCompletedIntroModules } = useContext(AssociateSetupContext);

  if (hasCompletedIntroModules) {
    return <Navigate to="/" replace />;
  }
  if (showLandingPage) {
    return (
      <IntroModulesLandingPage startStepper={() => setShowLandingPage(false)} />
    );
  }
  return <IntroModulesComponent />;
};

export default IntroModulesView;
